let refreshing = false

export const registerServiceWorker = () => {
    if (!('serviceWorker' in navigator)) return

    window.addEventListener('load', async () => {
        try {
            const registration = await navigator.serviceWorker.register('/sw.js')
            window.dispatchEvent(new CustomEvent('pwa-ready', { detail: { registration } }))

            if (registration.waiting && navigator.serviceWorker.controller) {
                window.dispatchEvent(new CustomEvent('pwa-update-available', {
                    detail: { registration },
                }))
            }

            registration.addEventListener('updatefound', () => {
                const worker = registration.installing
                if (!worker) return

                worker.addEventListener('statechange', () => {
                    if (worker.state === 'installed' && navigator.serviceWorker.controller) {
                        window.dispatchEvent(new CustomEvent('pwa-update-available', {
                            detail: { registration },
                        }))
                    }
                })
            })
        } catch (error) {
            window.dispatchEvent(new CustomEvent('pwa-registration-error', {
                detail: { error },
            }))
        }
    })

    navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshing) return
        refreshing = true
        window.location.reload()
    })
}

export const applyServiceWorkerUpdate = registration => {
    if (registration && registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    }
}
